export const listServices = state => state.services.allServices;

export const showService = (state, serviceId) => state.services.allServices.find(s => s.id === serviceId);

export const getTotalCount = state => state.services.totalCount;

export const listServicesFilters = state => state.services.filters;
